import type {ComponentType} from 'react';

import {colors} from 'shells/colors/colors';
import {CalendarSquareRegularActivityIcon} from 'shells/icon/svg/calendar-square-regular-activity-icon';
import {CheckCircleRegularIcon} from 'shells/icon/svg/check-circle-regular-icon';
import {CompanyRegularIcon} from 'shells/icon/svg/company-regular-icon';
import {LeadChevronRegularIcon} from 'shells/icon/svg/lead-chevron-regular-icon';
import {PersonCircleRegularIcon} from 'shells/icon/svg/person-circle-regular-icon';

import type {EntityFormIconType} from './types';

type EntityIconDetails = {
    icon: ComponentType<any>;
    iconColor: string;
    backgroundColor: string;
};

export const ENTITY_ICON_DETAILS: Record<EntityFormIconType, EntityIconDetails> = {
    accounts: {
        icon: CompanyRegularIcon,
        iconColor: colors.company,
        backgroundColor: colors.plumBg,
    },
    contacts: {
        icon: PersonCircleRegularIcon,
        iconColor: colors.blue600,
        backgroundColor: colors.blue100,
    },
    leads: {
        icon: LeadChevronRegularIcon,
        iconColor: colors.green600,
        backgroundColor: colors.green200,
    },
    activities: {
        icon: CalendarSquareRegularActivityIcon,
        iconColor: colors.red700,
        backgroundColor: colors.red100,
    },
    tasks: {
        icon: CheckCircleRegularIcon,
        iconColor: colors.yellow700,
        backgroundColor: colors.yellow100,
    },
};
